<button type="button" class="flex w-full items-center justify-between p-4 hover:bg-[#F3F4F6]" (click)="handleLogout()">
  <div class="flex flex-col gap-y-1">
    <span class="line-clamp-2 text-[14px]">Log Out</span>
  </div>
</button>
